import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import Button from "../Button";
import { Body, Heading } from "../Text";
export var DialogHeader = function DialogHeader(_ref) {
  var className = _ref.className,
      children = _ref.children,
      closeLabel = _ref.closeLabel,
      description = _ref.description,
      end = _ref.end,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'default' : _ref$mode,
      onClose = _ref.onClose,
      start = _ref.start,
      title = _ref.title;
  var classes = classNames('Dialog-header', className);
  return /*#__PURE__*/React.createElement(Box, {
    className: classes,
    divider: mode === 'compact' ? null : {
      color: 'light',
      side: 'bottom',
      width: 1
    },
    flex: {
      alignItems: 'center',
      direction: 'row',
      justifyContent: 'flex-end'
    },
    flexBasis: "auto",
    flexGrow: 1,
    flexShrink: 0,
    padding: {
      bottom: mode === 'compact' ? 4 : 16,
      left: 20,
      right: 12,
      top: 16
    }
  }, (children || description || title) && /*#__PURE__*/React.createElement(Box, {
    flex: {
      direction: 'column'
    },
    flexBasis: "100%",
    flexGrow: 1,
    flexShrink: 1
  }, /*#__PURE__*/React.createElement(Heading, null, title || children), description && /*#__PURE__*/React.createElement(Body, null, description)), closeLabel && onClose && /*#__PURE__*/React.createElement(Button, {
    ghost: true,
    hideLabel: true,
    onClick: onClose,
    icon: "cancel",
    label: closeLabel
  }));
};